// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__31guw","col":"styles_col__26lPc"};